var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"virtual-touch-keyboard",class:[ 'theme-dark', 'palette-grey', ("layout-" + _vm.layoutName), _vm.customClass ]},[(_vm.visible)?_c('VueTouchKeyboard',{attrs:{"options":_vm.options,"layout":_vm.layout,"cancel":_vm.hide,"accept":_vm.accept,"change":_vm.change,"input":_vm.input}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c7f709a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/terminal/app/modules/shared/peripherals/VirtualKeyboard.vue
// module id = 2659
// module chunks = 0